import React from 'react'
import "./footer.css"
import qr from "../Images/QRimage.png"
import dlogo from "../Images/download.png"
import applogo from "../Images/apple.png"
import googlelogo from "../Images/googleplay.png"
import agppgallery from "../Images/appgallery.png"


function Footer() {
  return (
    <div className='footer'>
        <div className='footer-up'>

            <div className='footer-one'>
                <div className='footer-oneUp'>
                    <p className='footer-title'>Customer Care</p>
                    <div className='footer-links'>
                        <p>Help Center</p>
                        <p>How to Buy</p>
                        <p>Returns & Refunds</p>
                        <p>Contact Us</p>
                    </div>
                   
                </div>

                <div className='footer-oneDown'>
                    <p className='footer-title'>Earn With Daraz</p>
                    <div className='footer-links'>
                        <p>Daraz University</p>
                        <p>Sell on Daraz</p>
                        <p>Code of Conduct</p>
                    </div>
                   
                </div>
            </div>

            <div className='footer-one'>
                <p className='footer-title'>Daraz</p>
                <div className='footer-links'>
                    <p>About Daraz</p>
                    <p>Careers</p>
                    <p>Daraz Blog</p>
                    <p>Terms & Conditions</p>
                    <p>Privacy Policy</p>
                    <p>Digital Payments</p>
                    <p>Daraz Customer University</p>
                    <p>Daraz Affiliate Program</p>
                </div>
                
            </div>

            <div className='footer-one'>
                <div className='footer-threeUp'>
                    <img src={qr} alt="" />
                    <div className='daraz-logo'>
                        <img src={dlogo} alt="" />
                        <p className='footer-active'>Happy Shopping</p>
                        <p>Download App</p>
                    </div>
                </div>
                <div className='footer-apps'>
                    <div className='apps'>
                        {/* Apple store */}
                        <img src={applogo} alt="" />
                        <div>
                            <p>Download on the</p>
                            <h3>App Store</h3>
                        </div>

                    </div>
                    <div className='apps'>
                        {/* Google play */}
                        <img src={googlelogo} alt="" />
                        <div>
                            <p>GET IT ON</p>
                            <h3>Google Play</h3>
                        </div>

                    </div>
                    <div className='apps'>
                        {/* AppGallery */}
                        <img src={agppgallery} alt="" />
                        <div>
                            <p>EXPLORE IT ON</p>
                            <h3>AppGallery</h3>
                        </div>
                    </div>

                </div>
            </div>    
        </div>

    </div>
  )
}

export default Footer